import { ValidatorFn, AbstractControl } from "@angular/forms";

export class NumberMaxMinValueValidator {
    static numberMaxMin(min: number, max: number): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            const item = control.value;

            if((item > max) || (item < min))
                return { 'incorrectMaxMinNumber': 'Informe um número entre ' + min + ' e ' + max };
            else
                return null;
        };
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/number-max-min-value.validation.ts
 **/